import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import Question from './question/Question'

import './Step.scss'
import AnimatedStep from './AnimatedStep'

interface StepProps {
  step: DenormalizedCustomizableQuestion
}

const Step = ({ step }: StepProps) => {
  return (
    <div className="step step--mobile" data-testid="step">
      <AnimatedStep>
        <Question question={step} />
      </AnimatedStep>
    </div>
  )
}

export default Step
